// 按路由写入页面标题、描述、正式地址，以及新闻页的结构化数据

const SITE = 'https://m.unidt.com'
const DEFAULT_TITLE = '华院计算-认知智能算法平台与工业智能体'
const DEFAULT_DESCRIPTION = '华院计算技术（上海）股份有限公司从事认知智能技术研发，提供认知智能算法平台、工业级智能体与运营决策智能体，服务工业制造等行业。'

function plainText(text) {
  return String(text || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

function clip(text, max) {
  const value = plainText(text)
  if (value.length <= max) return value
  return value.slice(0, max)
}

function upsertMeta(name, content) {
  let el = document.querySelector('meta[name="' + name + '"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertCanonical(pathname) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  const path = !pathname || pathname === '/' ? '/' : pathname
  el.setAttribute('href', SITE + path)
}

// 写入当前页面的标题、描述和正式地址
export function applyPageMeta(options) {
  const title = (options && options.title) || DEFAULT_TITLE
  const description = clip((options && options.description) || DEFAULT_DESCRIPTION, 120)
  document.title = title
  upsertMeta('description', description)
  upsertCanonical(options && options.path)
}

// 用路由上配置的 meta 写入页面信息
export function applyRouteMeta(route) {
  const meta = (route && route.meta) || {}
  applyPageMeta({
    title: meta.title,
    description: meta.description,
    path: meta.canonical || (route && route.path)
  })
}

// 新闻正文到达后写入 Article 结构化数据；没有正文则不写
export function setArticleJsonLd(article, id) {
  const existing = document.getElementById('article-jsonld')
  if (existing && existing.parentNode) existing.parentNode.removeChild(existing)
  const text = plainText(article && article.content)
  if (!article || !article.title || !text) return
  const script = document.createElement('script')
  script.id = 'article-jsonld'
  script.type = 'application/ld+json'
  script.text = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    datePublished: article.create_time,
    description: clip(text, 140),
    mainEntityOfPage: SITE + '/news/' + id,
    author: { '@type': 'Organization', name: '华院计算技术（上海）股份有限公司' },
    publisher: { '@type': 'Organization', name: '华院计算技术（上海）股份有限公司' }
  })
  document.head.appendChild(script)
}



// WEBPACK FOOTER //
// ./src/utils/pageMeta.js